<template>
  <thead :class="{ 'ed-table__header--scroll': headerIsFixed }">
    <tr>
      <th v-if="checkbox" class="ed-table__header ed-table__header--checkbox">
        <tooltip direction="top">{{ headerSelectAll }}</tooltip>
        <checkbox :id="'headerCheckbox_' + tableId" ref="headerCheckbox" @check="selectAll" @uncheck="unselectAll"></checkbox>
      </th>
      <th v-for="head in header" class="ed-table__header" :data-columnName="head.reference" v-show="head.show">
        {{ head.name }} <span class="icon-tri-croissant ed-table__sort ed-table__sort--up" @click="head.headFunctionUp(head.reference)" v-if="!noAction && head.headFunctionUp && head.headFunctionDown"></span><span class="icon-tri-decroissant ed-table__sort ed-table__sort--down" @click="head.headFunctionDown(head.reference)" v-if="!noAction && head.headFunctionUp && head.headFunctionDown"></span>
        <div class="ed-table__header--drag icon-resize-column" @click.stop="" v-if="resizable"></div>
        <div class="ed-table__header-search-trigger icon-research" @click.stop="searchDisplay(this.event)" v-if="!noAction && head.search"></div>
        <span class="ed-table__header-close-search icon-close" @click="emitCloseSearch(head.reference)" v-if="!noAction"></span>
      </th>
      <th v-for="action in actions" class="ed-table__header ed-table__header--action" v-if="!action.reference"></th>
    </tr>
    <tr class="ed-table__search-row hidden">
      <th class="ed-table__header" v-if="checkbox"></th>
      <th class="ed-table__header" v-for="head in header" v-if="head.show">

        <span  v-if="head.type && head.type.name === 'date'">
          <div class="ed-pull-right-layout">
            <div class="ed-pull-right-layout__first-elmt">
              <span class="ed-table__imput-label">du</span>
              <div class="ed-table__input-container ed-table__input-container--multiple">
                <input type="date" class="ed-table__input" :id="'search' + head.type.referenceStart" @keydown.enter="emitSearch(head.type.referenceStart)">
              </div>
              <br>
              <span class="ed-table__imput-label">au</span>
              <div class="ed-table__input-container ed-table__input-container--multiple">
                <input type="date" class="ed-table__input" :id="'search' + head.type.referenceEnd" @keydown.enter="emitSearch(head.type.referenceEnd)">
              </div>
            </div>
            <div class="ed-pull-right-layout__second-elmt">
              <button class="ed-table__header-button" @click="dateEmitSearch(head.type.referenceStart, head.type.referenceEnd)"><span class="icon-research"></span></button>
            </div>
          </div>
        </span>

        <select :id="'search' + head.reference" class="ed-table__input-container" v-else-if="head.type && head.type.name === 'select'" v-on:change="emitSelectSearch(head.reference)">
          <option value="" disabled selected>{{ chooseFilterMessage }}</option>
          <option :value="index" v-for="(selectOption, index) in head.type.array">{{ selectOption.name }}</option>
        </select>

        <div class="ed-table__input-container" v-else>
          <span class="ed-table__input-icon icon-research" @click.prevent.stop="emitSearch(head.reference)"></span>
          <input type="text" class="ed-table__input" :id="'search' + head.reference" @keydown.enter="emitSearch(head.reference)" :placeholder="headerSearchPlaceholder">
        </div>

        <div class="ed-table__borders" v-if="resizable"></div>
      </th>
      <th v-for="action in actions" class="ed-table__header ed-table__header--action" v-if="!action.reference"></th>
    </tr>
  </thead>
</template>

<script>

  export default {
    name: 'edTableHeader',
    data() {
      return {
        thisTableBody: this.tableBody,
        headerIsFixed: false,
         chooseFilterMessage: 'Select a filter'
      };
    },
    props: {
      tableId: String,
      headerSelectAll: String,
      headerSearchPlaceholder: String,
      tableBody: Array,
      header: Array,
      actions: Array,
      checkbox: Boolean,
      resizable: Boolean,
      fixHeader: Boolean,
      noAction: Boolean,
    },
    methods: {

      selectAll() {
        const allCheckboxes = [];
        /* Get  all checkboxes that are linked to an element row */
        for (let checkList = 0; checkList < this.tableBody.length; checkList += 1) {
          allCheckboxes.push(document.getElementById(`${this.tableId}${this.tableBody[checkList].id}`));
        }
        for (let i = 0; i < allCheckboxes.length; i += 1) {
          /* Check all these checkboxes */
          if (!allCheckboxes[i].checked) {
            allCheckboxes[i].click();
          }
        }
      },

      unselectAll() {
        const allCheckboxes = [];
        /* Get  all checkboxes that are linked to an element row */
        for (let checkList = 0; checkList < this.tableBody.length; checkList += 1) {
          allCheckboxes.push(document.getElementById(`${this.tableId}${this.tableBody[checkList].id}`));
        }
        for (let i = 0; i < allCheckboxes.length; i += 1) {
           /* Uncheck all these checkboxes */
          if (allCheckboxes[i].checked) {
            allCheckboxes[i].click();
          }
        }
      },

      searchDisplay(event) {
        const searchRowTable = document.getElementsByClassName('ed-table__search-row')[0];
        if (searchRowTable.classList.contains('hidden')) {
          searchRowTable.classList.remove('hidden');
          document.getElementById(`search${event.target.parentNode.getAttribute('data-columnName')}`).focus();
        } else {
          searchRowTable.className += ' hidden';
        }
      },

      emitSearch(headReference) {
        const value = { value: document.getElementById(`search${headReference}`).value, field: headReference };
        this.$emit('clickSearchHeader', value);
      },

      emitSelectSearch(headReference) {
        let value;
        const headerIndex = document.getElementById(`search${headReference}`).value;
        const headTarget = this.header[this.header.findIndex(elmt => elmt.reference === headReference)];
        if (headTarget.type.array[headerIndex].keys) {
          for (let i = 0; i < headTarget.type.array[headerIndex].keys.length; i += 1) {
            value = { value: headTarget.type.array[headerIndex].keys[i].value, field: headTarget.type.array[headerIndex].keys[i].name };
            this.$emit('clickSearchHeader', value);
          }
        } else {
          value = { value: headTarget.type.array[headerIndex].value, field: headReference };
          this.$emit('clickSearchHeader', value);
        }
      },

      dateEmitSearch(referenceStart, referenceEnd) {
        this.emitSearch(referenceStart);
        this.emitSearch(referenceEnd);
      },

      emitCloseSearch(headReference) {
        let value;
        let headerIndex = this.header.findIndex(elmt => elmt.reference === headReference);
        if (this.header[headerIndex].type && this.header[headerIndex].type.name === 'date') {
          value = {
            value: [document.getElementById(`search${this.header[headerIndex].type.referenceStart}`).value, document.getElementById(`search${this.header[headerIndex].type.referenceEnd}`).value],
            field: [this.header[headerIndex].type.referenceStart, this.header[headerIndex].type.referenceEnd],
          };
        } else {
          value = { value: document.getElementById(`search${headReference}`).value, field: headReference };
        }
        this.$emit('clickCloseSearch', value);
      },
    },
    mounted() {
      let locale = navigator.language;

      locale = locale.substring(0, 2);

      if (locale === 'fr') {
        this.chooseFilterMessage = "Choisissez un filtre";
      } else if (locale === 'es') {
        this.chooseFilterMessage = "Eligir un filtro";
      }
    },
  };
</script>



// WEBPACK FOOTER //
// edTableHeader.vue?9041a92c